import React, {Component} from 'react';

export default class GenericNotFound extends Component {
    render(){
        return (
        <div><h2>This is Route not Found Page</h2></div>
        );
    }
}